/* Peggy Bakes — serve the header logo at the size we actually display it.

   Horizon builds the logo's srcset from settings.logo_height, which Shopify
   caps at 100. We display the logo at 150px tall (257px wide) via CSS, so the
   theme's 1x/2x candidates (171px and 342px) are too small and the browser
   stretches them — that is the blur. The srcset uses x-descriptors, so the
   browser picks purely on pixel density and never notices the CSS size.

   Fix: drop the srcset and request one generously sized file from Shopify's
   image CDN. The source is a 1700px render of the vector logo, so there is
   plenty to work with. ~40KB, cached, loaded once. */
(function () {
  var TARGET_WIDTH = 800;

  function fix() {
    var logos = document.querySelectorAll('.header-logo__image, #header-component img.header-logo__image');
    if (!logos.length) return false;
    for (var i = 0; i < logos.length; i++) {
      var el = logos[i];
      if (el.getAttribute('data-pb-logo')) continue;
      var src = el.currentSrc || el.src || '';
      if (!src) continue;
      var parts = src.split('?');
      var base = parts[0];
      var params = new URLSearchParams(parts[1] || '');
      params.set('width', String(TARGET_WIDTH));
      params.delete('height');
      el.removeAttribute('srcset');
      el.removeAttribute('sizes');
      el.setAttribute('data-pb-logo', '1');
      el.src = base + '?' + params.toString();
    }
    return true;
  }

  if (document.readyState !== 'loading') fix();
  else document.addEventListener('DOMContentLoaded', fix);

  var tries = 0;
  var timer = setInterval(function () {
    if (fix() || ++tries > 20) clearInterval(timer);
  }, 250);
})();